export const RESET_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const RECOVERY_CODE_SENT_MESSAGE =
  "If an account exists for this email address, a verification code has been sent.";

export const RESET_PASSWORD_REQUIREMENTS_MESSAGE =
  "Your new password does not meet the password requirements.";

export const RESEND_COOLDOWN_SECONDS = 30;

export const getPasswordResetRedirectUrl = () => {
  const origin = String(process.env.REACT_APP_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
  return `${origin}/reset-password`;
};

export const isValidResetEmail = (value) => RESET_EMAIL_PATTERN.test(String(value || "").trim());

export const isValidEmailOtp = (value) => /^\d{6}$/.test(String(value || "").trim());

const messageOf = (error) => String(error?.message || error || "").toLowerCase();

const isNetworkError = (error) => {
  const message = messageOf(error);
  const name = String(error?.name || "").toLowerCase();
  return (
    name === "typeerror"
    || message.includes("failed to fetch")
    || message.includes("networkerror")
    || message.includes("network request failed")
    || message.includes("load failed")
  );
};

export const mapPasswordResetRequestError = (error) => {
  const message = messageOf(error);

  if (isNetworkError(error)) {
    return "Unable to send a reset email right now. Please check your connection and try again.";
  }

  if (message.includes("redirect") || message.includes("not allowed")) {
    return "Password reset is not configured for this app URL. Add this site to the Supabase redirect allow list, then try again.";
  }

  if (message.includes("rate") || message.includes("too many")) {
    return "Too many reset requests. Please wait a moment and try again.";
  }

  return "Unable to send a reset email. Please try again.";
};

export const shouldAdvanceAfterRecoveryRequest = (error) => {
  if (!error) return true;
  const message = messageOf(error);
  if (isNetworkError(error)) return false;
  if (message.includes("rate") || message.includes("too many")) return false;
  if (message.includes("redirect") || message.includes("not allowed")) return false;
  return true;
};

export const mapRecoveryOtpError = (error) => {
  const message = messageOf(error);

  if (isNetworkError(error)) {
    return "Unable to verify the code right now. Please check your connection and try again.";
  }

  if (message.includes("expired")) {
    return "That verification code has expired. Please request a new code.";
  }

  if (message.includes("already") && (message.includes("used") || message.includes("consumed"))) {
    return "This verification code has already been used. Please request a new code.";
  }

  if (message.includes("rate") || message.includes("too many")) {
    return "Too many attempts. Please wait and try again.";
  }

  if (
    message.includes("invalid")
    || message.includes("otp")
    || message.includes("token")
    || message.includes("code")
  ) {
    return "That verification code is incorrect.";
  }

  return "Something went wrong while verifying the code. Please try again.";
};

export const mapRecoveryPasswordUpdateError = (error) => {
  const message = messageOf(error);

  if (isNetworkError(error)) {
    return "Unable to update your password right now. Please try again.";
  }

  if (
    message.includes("weak")
    || message.includes("password should be")
    || message.includes("at least")
  ) {
    return RESET_PASSWORD_REQUIREMENTS_MESSAGE;
  }

  if (
    message.includes("session")
    || message.includes("jwt expired")
    || message.includes("not authenticated")
    || message.includes("expired")
  ) {
    return "Your password reset session has expired. Please request a new verification code.";
  }

  return "Something went wrong while updating your password. Please try again.";
};
